module.exports = new __parcel__URL__("github.b513e581.png").toString();